import { $ } from './utils.js';

/* ─── Apply Theme ─────────────────────── */
export let theme = localStorage.getItem('sm-theme') || 'system';

export function applyTheme(t) {
	theme = t;
	localStorage.setItem('sm-theme', t);
	// Resolve 'system' to actual light/dark
	const resolved = t === 'system'
		? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
		: t;
	document.documentElement.setAttribute('data-theme', resolved);
	const sun = $('#icon-sun');
	const moon = $('#icon-moon');
	const sys = $('#icon-system');
	sun.style.display = t === 'dark' ? 'block' : 'none';
	moon.style.display = t === 'light' ? 'block' : 'none';
	if (sys) sys.style.display = t === 'system' ? 'block' : 'none';
	const mobSun = document.querySelector('.mob-sun');
	const mobMoon = document.querySelector('.mob-moon');
	const mobSys = document.querySelector('.mob-system');
	if (mobSun) mobSun.style.display = t === 'dark' ? 'block' : 'none';
	if (mobMoon) mobMoon.style.display = t === 'light' ? 'block' : 'none';
	if (mobSys) mobSys.style.display = t === 'system' ? 'block' : 'none';
}

// Listen for system theme changes
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
	if (theme === 'system') applyTheme('system');
});

/* ─── Theme Toggle ────────────────────── */
export function toggleTheme() {
	const order = ['system', 'light', 'dark'];
	applyTheme(order[(order.indexOf(theme) + 1) % 3]);
}
